import React, { useState } from "react"

// Material UI
import Masonry from "@mui/lab/Masonry"
import { Container, Typography, ButtonBase } from "@mui/material"

import MasonryCard from "./MasonryCard"

const MasonryGrid = ({ items, limit }) => {
  // Split masonry grid in pieces to work around 2000px height limit of MUI v5
  items.sort((a, b) => a.comingSoon - b.comingSoon)
  const maxNumberArray = 6 // How many items will be in a single Masonry
  const [maxNumberTotal, setMaxNumberTotal] = useState(limit || 30) // Limit the number of images shown in total

  // Split the whole array in individual separate arrays of 6 images each
  const splitArrays = items
    .slice(0, maxNumberTotal)
    .reduce((resultArray, item, index) => {
      const chunkIndex = Math.floor(index / maxNumberArray)

      if (!resultArray[chunkIndex]) {
        resultArray[chunkIndex] = [] // start a new chunk
      }

      resultArray[chunkIndex].push(item)

      return resultArray
    }, [])

  const handleClick = () => {
    setMaxNumberTotal(maxNumberTotal + 6)
  }

  return (
    <>
      <Container
        maxWidth="lg"
        sx={{
          marginTop: 6,
          marginBottom: 6,
        }}
      >
        {splitArrays.map((singleArray, index) => {
          // Return one masonry grid for each 6 items
          return (
            <Masonry
              columns={{ sm: 1, md: 2 }}
              spacing={4}
              sx={{
                overflow: `hidden`, // prevent adding a scrollbar to this component if height is over 2000 px
              }}
              key={`masonry-grid-${index}`}
            >
              {singleArray.map((item, index) => (
                <MasonryCard item={item} key={item.title} index={index} />
              ))}
            </Masonry>
          )
        })}
      </Container>
      {limit && maxNumberTotal < items.length && (
        <Container sx={{ display: `flex`, justifyContent: `center` }}>
          <ButtonBase
            onClick={() => {
              handleClick()
            }}
            sx={{
              marginBottom: 6,
              paddingLeft: 2,
              paddingRight: 2,
              paddingTop: 1,
              paddingBottom: 1,
              fontSize: `1rem`,
              border: `1px solid #263847`,
              color: `titles.main`,
              textTransform: `uppercase`,
              "&:hover": {
                backgroundColor: `titles.main`,
                color: `background.light`,
                border: `1px solid transparent`,
                opacity: 1,
              },
            }}
          >
            <Typography variant="monoMedium">Show more</Typography>
          </ButtonBase>
        </Container>
      )}
    </>
  )
}

export default MasonryGrid
